import { render, staticRenderFns } from "./GroupHomeOption.vue?vue&type=template&id=5f3f0c6e&scoped=true"
import script from "./GroupHomeOption.vue?vue&type=script&lang=js"
export * from "./GroupHomeOption.vue?vue&type=script&lang=js"
import style0 from "./GroupHomeOption.vue?vue&type=style&index=0&id=5f3f0c6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3f0c6e",
  null
  
)

export default component.exports